import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function useLogined() {
  const logined = Recoil.useRecoilValue(AppStore.app.logined);
  return logined;
}
